/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the BannedBulkCreateResponseDTO interface.
 */
export function instanceOfBannedBulkCreateResponseDTO(value) {
    return true;
}
export function BannedBulkCreateResponseDTOFromJSON(json) {
    return BannedBulkCreateResponseDTOFromJSONTyped(json, false);
}
export function BannedBulkCreateResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'inserted': json['inserted'] == null ? undefined : json['inserted'],
    };
}
export function BannedBulkCreateResponseDTOToJSON(json) {
    return BannedBulkCreateResponseDTOToJSONTyped(json, false);
}
export function BannedBulkCreateResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'inserted': value['inserted'],
    };
}
